export const tableConfiguration = {
    MinColumnWidthForAccommodation: 170,
    MinColumnWidthForRoomType: 140,
    MinColumnWidthForFloor: 100
};
